<template>
    <div>
        <SafeDateRangePicker
            v-model:start-date="activeRedemption.start_date"
            v-model:end-date="activeRedemption.end_date"
            :config="dateStartConfig"
            class="mb-8"
        >
            <template #default="{ openMenu, startValue, endValue }">
                <div class="grid grid-cols-2 gap-4">
                    <div class="col-span-1">
                        <Input
                            label="Pick-up date" placeholder="Pick-up"
                            name="start_date" id="rent-start"
                            :options="{ icon: 'calendar', iconPosition: 'left' }"
                            :errors="tripFormErrors"
                        >
                            <template #input>
                                <input
                                    :value="startValue" readonly @click="openMenu"
                                    name="rent_start_date" id="rent-start"
                                    :class="[
                                        'relative block w-full h-10 rounded border bg-white dark:bg-slate-800 py-1.5 pl-10 text-gray-800 dark:text-gray-100 placeholder:text-slate-500 dark:text-slate-400 focus:z-10 focus:ring-0 placeholder:text-sm cursor-pointer',
                                        tripFormErrors['start_date']
                                            ? 'border-red-500 hover:border-red-500 focus:border-red-500'
                                            : 'border-slate-200 dark:border-slate-700 focus:border-slate-800 hover:border-slate-800',
                                    ]"
                                    placeholder="Start"
                                    data-hs-id="hs-redemption-rental-start"
                                />
                            </template>
                        </Input>
                    </div>
                    <div class="col-span-1">
                        <Input
                            label="Drop-off date" placeholder="Drop-off"
                            id="rent-end"
                            :options="{ icon: 'calendar', iconPosition: 'left' }"
                        >
                            <template #input>
                                <input
                                    :value="endValue" readonly @click="openMenu"
                                    name="rent_end_date" id="rent-end"
                                    class="relative block w-full h-10 rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-1.5 pl-10 text-gray-800 dark:text-gray-100 placeholder:text-slate-500 dark:text-slate-400 focus:z-10 focus:ring-0 focus:border-slate-800 hover:border-slate-800 placeholder:text-sm cursor-pointer"
                                    placeholder="End"
                                    data-hs-id="hs-redemption-rental-end"
                                />
                            </template>
                        </Input>
                    </div>
                </div>
            </template>
        </SafeDateRangePicker>

        <div class="grid grid-cols-2 gap-4 mb-8">
            <div class="col-span-1">
                <Input
                    label="Pick-up location" id="pick-up-location"
                    placeholder="Pick-up" name="pick_up_location"
                    v-model:inputValue="activeRedemption.pickup_location"
                    :options="{ inputClass: 'h-10' }"
                />
            </div>
            <div class="col-span-1">
                <Input
                    label="Drop-off location" id="drop-off-location"
                    placeholder="Drop-off" name="drop_off_location"
                    v-model:inputValue="activeRedemption.dropoff_location"
                    :options="{ inputClass: 'h-10' }"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';
import SafeDateRangePicker from '@/components/ui/SafeDateRangePicker.vue';
import Input from '@/components/ui/inputs/ui-input.vue';

defineProps({
    dateStartConfig: { type: Object, required: true },
});

const { activeRedemption, tripFormErrors } = storeToRefs(useTripsStore());
</script>
